export default __webpack_public_path__ + "static/media/fill.b8742a16.svg";